<template>
  <div>
    <main id="main">
      <div>
        <section class="mainVis move">
          <div class="txt">
            <h2>
              OnCrewSoft wants to <span>build a good world together</span>
            </h2>
            <p>
              고객에게 한발 더 다가가기 위하여
              <span
                >새로운 패러다임과 IT 환경에서의 이해를 통해 <br />축적된
                노하우와 기술력으로 </span
              >최적의 솔루션과 서비스를 제공하겠습니다.
            </p>
            <router-link
              to="/sees/seesjobmind"
              class="btn_more"
              style="font-size: 20px"
              >More view</router-link
            >
          </div>
        </section>
      </div>

      <article class="main_know main_sc">
        <div class="inner_box">
          <h3>Do you know <em>Business Automation</em>?</h3>
          <ul class="clearfix">
            <li>
              <v-avatar size="140">
                <v-img src="@/assets/img/main/icon_sc1-1.png" alt="" />
              </v-avatar>
              <dl>
                <dt>SYSMIND</dt>
                <dd>
                  시스템 작업 수행 및 정보수집을 자동화 하고<br />통제를
                  기반으로 운영하는<br />시스템 운영 자동화 솔루션입니다.<br />
                  <router-link
                    to="/sees/seesSysmind#sysmind"
                    class="btn_more"
                    >More view</router-link
                  >
                </dd>
              </dl>
            </li>
            <li>
              <v-avatar size="140">
                <v-img src="@/assets/img/main/icon_sc1-3.png" alt="" />
              </v-avatar>
              <dl>
                <dt>JOBMIND</dt>
                <dd>
                  배치 작업 업무 효율화 및 체계화된 배치 관리 프로세스를 <br />
                  구축하며 안정적인 배치 업무 관리를 위한 <br />배치 작업 스케줄러
                  솔루션입니다.
                  <router-link
                    to="/sees/seesJobmind#benefit"
                    class="btn_more"
                    >More view</router-link
                  >
                </dd>
              </dl>
            </li>
            <li>
              <v-avatar size="140">
                <v-img src="@/assets/img/main/icon_sc1-2.png" alt="" />
              </v-avatar>
              <dl>
                <dt>CRONMIND</dt>
                <dd>
                  OS에서 기본제공 되는 Crontab기능에 대한<br />작업수행
                  모니터링, Web기반 UI, 수행결과 알림 기능을 통해<br />통합관리의
                  기반을 제공하는 솔루션입니다.
                  <router-link
                    to="/sees/seesCronmind#benefit"
                    class="btn_more"
                    >More view</router-link
                  >
                </dd>
              </dl>
            </li>
          </ul>
        </div>
      </article>

      <article class="main_sc2 clearfix">
        <section
          :style="{
            'background-image':
              'url(' + require('@/assets/img/main/img_sc2-1.jpg') + ')',
          }"
        >
          <a>
            <p class="tit">Section 01</p>
            <div class="txt">
              <div class="icon">
                <v-img
                  src="@/assets/img/main/icon_sc2-1.png"
                  alt=""
                  style="width: 70%; height: 70%; margin: 15%"
                />
              </div>
              <dl>
                <dt>SYSMIND</dt>
                <dd>
                  <ul>
                    <li style="text-align: left">기동/재기동 업무 자동화</li>
                    <li style="text-align: left">일상점검 업무 자동화</li>
                    <li style="text-align: left">CI 구성관리 업무 자동화</li>
                    <li style="text-align: left">S/W 배포 업무 자동화</li>
                    <li style="text-align: left">수행결과 수집 업무 자동화</li>
                  </ul>
                </dd>
              </dl>
            </div>
          </a>
        </section>
        <section
          :style="{
            'background-image':
              'url(' + require('@/assets/img/main/img_sc2-2.jpg') + ')',
          }"
        >
          <a>
            <p class="tit">Section 02</p>
            <div class="txt">
              <div class="icon">
                <v-img
                  src="@/assets/img/main/icon_sc2-2.png"
                  alt=""
                  style="width: 70%; height: 70%; margin: 15%"
                />
              </div>
              <dl>
                <dt>JOBMIND</dt>
                <dd>
                  <ul>
                    <li style="text-align: left">
                      정기/수시 작업관리, 이기종 시스템 배치 연계
                    </li>
                    <li style="text-align: left">
                      유연한 결재 시스템, 배치 수행의 안정성 확보
                    </li>
                    <li style="text-align: left">
                      SMS/E-mail 통한 오류 통보, 배치 오류 발생시 조치사항 관리
                    </li>
                    <li style="text-align: left">
                      캘린더 관리, 자원관리 및 분산 처리
                    </li>
                  </ul>
                </dd>
              </dl>
            </div>
          </a>
        </section>
        <section
          :style="{
            'background-image':
              'url(' + require('@/assets/img/main/img_sc2-3.jpg') + ')',
          }"
        >
          <a>
            <p class="tit">Section 03</p>
            <div class="txt">
              <div class="icon">
                <v-img
                  src="@/assets/img/main/icon_sc2-3.png"
                  alt=""
                  style="width: 70%; height: 70%; margin: 15%"
                />
              </div>
              <dl>
                <dt>CRONMIND</dt>
                <dd>
                  <ul>
                    <li style="text-align: left">체계적인 Crontab 통합관리</li>
                    <li style="text-align: left">
                      이력 및 권한관리를 통한 작업통제 강화
                    </li>
                    <li style="text-align: left">
                      작업 등록 및 결제기능을 통한 작업수행 신뢰도 상향
                    </li>
                    <li style="text-align: left">
                      작업수행 모니터링을 통한 신속한 대응체계 마련
                    </li>
                  </ul>
                </dd>
              </dl>
            </div>
          </a>
        </section>
      </article>

      <article class="main_con main_sc">
        <div class="inner_box clearfix">
          <section class="main_pd">
            <h3><em>Produce</em> products without completeness.</h3>
            <ul class="clearfix">
              <li>
                <router-link to="/product/cubeone">
                  <div class="img" style="background: #125fa5; display: flex">
                    <v-img
                      src="@/assets/img/main/logo_sc3-1.png"
                      alt=""
                      style="
                        margin: 0 auto;
                        max-width: 35%;
                        align-items: center;
                      "
                    />
                  </div>
                  <dl>
                    <dt>Cubeone</dt>
                    <dd>
                      Cubeone™은 FIPS-140 기준을 만족하며 <br />국정원
                      암호모듈검증필 암호모듈(KLIB V.2.x) 이 <br />탑재된 안전한
                      제품입니다.
                    </dd>
                  </dl>
                </router-link>
              </li>
              <!--
              <li>
                <router-link to="/oncrew/salesnet">
                  <div class="img" style="background: #e83900; display: flex">
                    <v-img
                      src="@/assets/img/main/logo_sc3-2.png"
                      alt=""
                      style="
                        margin: 0 auto;
                        max-width: 50%;
                        align-items: center;
                      "
                    />
                  </div>
                  <dl>
                    <dt>SalesNet</dt>
                    <dd>
                      Salesnet은 복잡한 IT 환경을 간소화하여 <br>기업의 업무를 쉽고 빠르게 처리할 수 있는<br /> 혁신적인 ERP 시스템을 제공합니다
                                  </dd>
                  </dl>
                </router-link>
              </li>
-->
              <li>
                <router-link to="/quest/shareplex">
                  <div class="img" style="background: #ef7c00; display: flex">
                    <v-img
                      src="@/assets/img/main/logo_sc3-6.png"
                      alt=""
                      style="
                        margin: 0 auto;
                        max-width: 45%;
                        align-items: center;
                      "
                    />
                  </div>
                  <dl>
                    <dt>QUEST</dt>
                    <dt></dt>
                    <dd>
                      QUEST SOFTWARE는<br />Shareplex, Livereorg,AD
                      secure, TOAD <br />DB관리 및 데이터 보호 솔루션을
                      제공합니다
                    </dd>
                  </dl>
                </router-link>
              </li>
            </ul>
          </section>

          <section class="main_notice">
            <h3>Check the <em>Notice</em></h3>
            <p>
              온크루소프트주식회사에 빠른 문의를 하실 수 있습니다.<br
                class="br"
              />최고의 솔루션과 서비스를 제공하기 위한 노력으로 신뢰할 수 있는
              기업, <br /><span>내일을 향해 달리는 기업이 되기 위해<br /></span>
              끊임없는 변화와 도전을 합니다.
            </p>
            <router-link to="/common/noticeVue" class="btn_more"
              >More view</router-link
            >
          </section>

          <section class="main_contact">
            <h3>Contact us</h3>
            <strong>02-6450-0851</strong>
            <p><span>견적상담.</span>Sales@oncrewsoft.com</p>
            <p><span>제품문의.</span>tech@oncrewsoft.com</p>
          </section>
        </div>
      </article>
    </main>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<style></style>
